module.exports = __webpack_public_path__ + "img/cuff button diameter.700ae627.png";